import React, { useContext } from "react";
import Header from "../Components/Header";
import Rightcontainer from "../Components/Rightcontainer";
import { Link } from "react-router-dom";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";

const Support = ({ handleShow }) => {
  const theme = localStorage.getItem("theme");

  // language
  const translations = {
    hi: {
      contact: "नीचे दिए गए प्लेटफ़ॉर्म पर हमसे संपर्क करें।",
      money: "राशि डालें  ",
      next: "आगे बड़े ",
      addAmount: "राशि जोड़ी जानी है ",
      referPerson: "रेफ़रल | ",
    },
    en: {
      contact: "Contact Us At Below Platforms.",
      money: "Enter Amount",
      next: "Next",
      addAmount: "Amount to be added",
      referPerson: "Referral",
    },
  };

  const { language } = useContext(LanguageContext);

  // change theme
  const styles = {
    backgroundColor: theme === "light" ? "#eefdd3" : "black",
    color: theme === "light" ? "black" : "#fff",
  };
  const styles1 = {
    color: theme === "light" ? "black" : "white",
  };

  return (
    <div>
      <div className="leftContainer mb_space pb-0 vh-100" style={styles}>
        <div className="Orher_page_main_section">
          <div className="support_box">
            <img className="w-50" src="./images/support.jpg" />
            <div class="support_content">
              <h2 className="animated-text mb-1">Need Help?</h2>
              <p className="mb-0">We're here to help you 24/7</p>
            </div>
          </div>
          <div className=" ">
            <div className=" mt-4" style={{ ...styles1 }}>
              {translations[language].contact}
            </div>
            <div className="row mt-3">
              {/* youtube */}
              {/* <div className="col-6 col-lg-4 col-md-3 col-sm-12 mb-3">
                <div className="support_samll_card_btn_type">
                  <a
                    className="cxy flex-column"
                    target="_blank"
                    href="https://youtu.be/0hNHiccgoMI?si=njTT0HryRxmQtWq7"
                  >
                    <img width="50px" src="/images/youtube.png" alt="" />
                    <span className="">Youtube</span>
                  </a>
                </div>
              </div> */}

              {/* mail */}
              {/* <div className="col-6 col-lg-4 col-md-3 col-sm-12 mb-3">
                <div className="support_samll_card_btn_type">
                  <a className="cxy flex-column" href="mailto:info@kkadda.in">
                    <img
                      width="50px"
                      src={process.env.PUBLIC_URL + "/images/mail.png"}
                      alt=""
                    />
                    <span className="">
                      {JSON.parse(localStorage.getItem("sitSetting")) ==
                      "undefined"
                        ? ""
                        : JSON.parse(localStorage.getItem("sitSetting"))
                            ?.supportMail}
                    </span>
                  </a>
                </div>
              </div> */}

              {/* whatsapp */}
              {/* <div className="col-6 col-lg-4 col-md-3 col-sm-12 mb-3">
                <div className="support_samll_card_btn_type">
                  {JSON.parse(localStorage.getItem("sitSetting")) ==
                  "undefined" ? (
                    ""
                  ) : JSON.parse(localStorage.getItem("sitSetting"))
                      ?.whatsappSupport ? (
                    <>
                      <a
                        href={
                          JSON.parse(localStorage.getItem("sitSetting")) ==
                          "undefined"
                            ? ""
                            : JSON.parse(localStorage.getItem("sitSetting"))
                                ?.whatsappSupport
                        }
                        target="_blank"
                      >
                        <img
                          width="50px"
                          src={process.env.PUBLIC_URL + "/images/whatsapp.png"}
                          alt=""
                        />
                        <span className="">WhatsApp</span>
                      </a>
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div> */}
              {/* call */}
              {/* <div className="col-6 col-lg-4 col-md-3 col-sm-12 mb-3">
                <div className="support_samll_card_btn_type">
                  <img
                    width="50px"
                    src={process.env.PUBLIC_URL + "/images/phone.png"}
                    alt=""
                  />
                  <span className="">
                    <a
                      target="_blank"
                      href={
                        JSON.parse(localStorage.getItem("sitSetting")) ==
                        "undefined"
                          ? ""
                          : "tel:" +
                            JSON.parse(localStorage.getItem("sitSetting"))
                              ?.CompanyMobile
                      }
                    >
                      {JSON.parse(localStorage.getItem("sitSetting")) ==
                      "undefined"
                        ? ""
                        : JSON.parse(localStorage.getItem("sitSetting"))
                            ?.CompanyMobile}
                    </a>
                  </span>
                </div>
              </div> */}

              {/* support-bx */}

              <div className="col-lg-12">
                <div>
                  <>
                    {JSON.parse(localStorage.getItem("sitSetting")) ==
                    "undefined" ? (
                      ""
                    ) : JSON.parse(localStorage.getItem("sitSetting"))
                        ?.whatsappSupport ? (
                      <a
                        class="what_support"
                        href={
                          JSON.parse(localStorage.getItem("sitSetting")) ==
                          "undefined"
                            ? ""
                            : JSON.parse(localStorage.getItem("sitSetting"))
                                ?.whatsappSupport
                        }
                        target="_blank"
                      >
                        <div class="what_app_icon">
                          <img src="/images/whatsapp-new-.png" alt=""></img>
                        </div>
                        <div className="text-center">
                          <h6 className="mb-0">WhatsApp</h6>
                          <small>Chat with us directly</small>
                        </div>
                      </a>
                    ) : (
                      ""
                    )}
                  </>

                  <>
                    {/* {JSON.parse(localStorage.getItem("sitSetting")) ==
                    "undefined" ? (
                      ""
                    ) : JSON.parse(localStorage.getItem("sitSetting"))
                        ?.supportTelegram ? (
                      <a
                        class="what_support"
                        href={
                          JSON.parse(localStorage.getItem("sitSetting")) ==
                          "undefined"
                            ? ""
                            : JSON.parse(localStorage.getItem("sitSetting"))
                                ?.supportTelegram
                        }
                        target="_blank"
                      >
                        <div
                          className="what_app_icon"
                          style={{ backgroundColor: "rgba(59,130,246,0.1)" }}
                        >
                          <img
                            src="/images/telegram.png"
                            style={{ width: "32px" }}
                            alt=""
                          ></img>
                        </div>
                        <div className="text-center">
                          <h6 className="mb-0">Telegram</h6>
                          <small>Chat with us directly</small>
                        </div>
                      </a>
                    ) : (
                      ""
                    )} */}
                  </>
                  {/* <a class="what_support" href="">
                    <div class="what_app_icon insta">
                      <img src="./images/instagram-new.png" alt=""></img>
                    </div>
                    <div className="text-center">
                      <h6 className="mb-0">Instagram</h6>
                      <small>Follow us for updates</small>
                    </div>
                  </a> */}
                  {/* <a class="what_support " href="#">
                    <div class="what_app_icon email_info">
                      <img src="./images/mail-new.png" alt=""></img>
                    </div>
                    <div className="text-center">
                      <h6 className="mb-0">Email Support</h6>
                      <small>Follow us for updates</small>
                    </div>
                  </a> */}
                   <a class="what_support " href="#">
                    <div class="support-icon phone">
                      <img src="/Call ringing animation.gif" alt="" />
                    </div>
                    <div className="text-center">
                      <h6 className="mb-0">Phone Support</h6>
                     <a
                          target="_blank"
                          href={
                            JSON.parse(localStorage.getItem("sitSetting")) ==
                            "undefined"
                              ? ""
                              : "tel:" +
                                JSON.parse(localStorage.getItem("sitSetting"))
                                  ?.CompanyMobile
                          }
                        >
                          {JSON.parse(localStorage.getItem("sitSetting")) ==
                          "undefined"
                            ? ""
                            : JSON.parse(localStorage.getItem("sitSetting"))
                                ?.CompanyMobile}
                        </a>
                    </div>
                  </a>
                </div>
                {/* <div className="support-bx bg-phon">
                  <h6>Get instant help from our team</h6>
                  <div className="d-flex align-items-center">
                    <div className="">
                     
                    </div>
                    <div>
                      <h4 className="mb-2" style={{ color: "black" }}>
                        Phone Support
                      </h4>
                      <h4 className="mb-0">
                        <a
                          target="_blank"
                          href={
                            JSON.parse(localStorage.getItem("sitSetting")) ==
                            "undefined"
                              ? ""
                              : "tel:" +
                                JSON.parse(localStorage.getItem("sitSetting"))
                                  ?.CompanyMobile
                          }
                        >
                          {JSON.parse(localStorage.getItem("sitSetting")) ==
                          "undefined"
                            ? ""
                            : JSON.parse(localStorage.getItem("sitSetting"))
                                ?.CompanyMobile}
                        </a>
                      </h4>
                    </div>
                  </div>
                </div> */}
              </div>
              {/* 
              <div className="col-12 col-lg-12 col-md-12 col-sm-12 mb-3">
                <p className="company_address" style={styles}>
                  <span style={styles}>Address:</span>
                  <span style={styles}>
                    {JSON.parse(localStorage.getItem("sitSetting")) ==
                      "undefined"
                      ? ""
                      : JSON.parse(localStorage.getItem("sitSetting"))
                        ?.CompanyAddress}
                  </span>
                </p>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      <div className="rightContainer">
        <Rightcontainer />
      </div>
    </div>
  );
};

export default Support;
